/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindOneQueryResponse, PrincipalRolesControllerFindOnePathParams, PrincipalRolesControllerFindOneQueryParams, PrincipalRolesControllerFindOne400, PrincipalRolesControllerFindOne401, PrincipalRolesControllerFindOne403, PrincipalRolesControllerFindOne404 } from "../../models/principalRolesController/PrincipalRolesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { principalRolesControllerFindOne } from "../../clients/principal-rolesService/principalRolesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const principalRolesControllerFindOneQueryKey = (id: PrincipalRolesControllerFindOnePathParams["id"], params: PrincipalRolesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/principal-roles/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type PrincipalRolesControllerFindOneQueryKey = ReturnType<typeof principalRolesControllerFindOneQueryKey>;
export function principalRolesControllerFindOneQueryOptions(id: PrincipalRolesControllerFindOnePathParams["id"], params?: PrincipalRolesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = principalRolesControllerFindOneQueryKey(id, params);
  return queryOptions<PrincipalRolesControllerFindOneQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindOne400 | PrincipalRolesControllerFindOne401 | PrincipalRolesControllerFindOne403 | PrincipalRolesControllerFindOne404>, PrincipalRolesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return principalRolesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a principal role assignment by id
 * {@link /api/v1/principal-roles/:id}
 */
export function usePrincipalRolesControllerFindOne<TData = PrincipalRolesControllerFindOneQueryResponse, TQueryData = PrincipalRolesControllerFindOneQueryResponse, TQueryKey extends QueryKey = PrincipalRolesControllerFindOneQueryKey>(id: PrincipalRolesControllerFindOnePathParams["id"], params?: PrincipalRolesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<PrincipalRolesControllerFindOneQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindOne400 | PrincipalRolesControllerFindOne401 | PrincipalRolesControllerFindOne403 | PrincipalRolesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? principalRolesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...principalRolesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PrincipalRolesControllerFindOne400 | PrincipalRolesControllerFindOne401 | PrincipalRolesControllerFindOne403 | PrincipalRolesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}